import styled from 'styled-components'

const ArchivedUsersContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export { ArchivedUsersContainer }
